<div class="content" *ngIf="!isMsp">
  <div class="container-fluid">
    <div class="page-title">
      <h1>Event Monitoring</h1>
      <button pButton type="button" label="Export" icon="pi pi-download" class="{{Confirm_button}}" (click)="dt.exportCSV()"></button>
    </div>
    <div class="page-filter clearfix multiple-filter">
      <div class="filter-flex">
        <div class="filter">
          <div class="filter-list name_title">
            <div class="filter-content">
              <!-- <span class="type">Company</span> -->
              <p-select [options]="CompanyOptions$ | async" [(ngModel)]="filterParam.regionId" (onChange)="refresh()"
                          [style]="{'width':'100%'}" placeholder="Company"></p-select>
            </div>
          </div>
          <div class="filter-list">
            <div class="filter-content">
              <!-- <span class="type">Status</span> -->
              <p-select [options]="statusOptions" [(ngModel)]="device_status" (onChange)="changeStatus()" [style]="{'width':'100%'}" placeholder="Status">
              </p-select>
            </div>
          </div>
          <div class="filter-list">
            <div class="filter-content">
              <!-- <span class="type">Range</span> -->
              <p-select [options]="rangeOptions" [(ngModel)]="selectedRange" (onChange)="dispatchRangeFilter()" [style]="{'width':'100%'}" placeholder="Range">
              </p-select>
            </div>
          </div>
        </div>
        <div class="filter search float-right">
          <div class="button">
            <!-- <input #gb type="text" pInputText placeholder="Search" class="pInputText"> -->
            <input type="text" pInputText placeholder="Search" (input)="dt.filterGlobal($event.target.value, 'contains')" class="pInputText">
          </div>
        </div>
      </div>
    </div>
    <div class="page-content border-t-radius-none">
      <!-- <p-dataTable [globalFilter]="gb" #dt exportFilename="eventLogs" [value]="eventLogs$ | async" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,20]">
        <p-column [sortable]="true" field="status" header="Status" [style]="{'width':'80px'}" styleClass="col-nowrap text-center">
          <ng-template let-col let-data="rowData" pTemplate="body">
            <span class="center" *ngIf="!data.isHardwareFault">
              <i class="fa {{data.icon}} {{data.status}}" aria-hidden="true"></i>
            </span>
            <div class="icon errorCodeIcon" [ngStyle]="{'background-color': data.faultLevelColor}" *ngIf="data.isHardwareFault">
              <span>H</span>
            </div>
          </ng-template>
        </p-column>
        <p-column [sortable]="true" field="Account" header="Account" [style]="{'width':'120'}" styleClass="col-nowrap">
        </p-column>
        <p-column [sortable]="true" field="time" header="Time" [style]="{'width':'180px'}" styleClass="col-nowrap">
          <ng-template let-col let-item="rowData" pTemplate="body">
            {{(item.time != null) ? ((item.timestamp * 1000) + ((localTimeZone + item.timeZone)* 60 * 60 * 1000) | date: 'yyyy/MM/dd HH:mm:ss') : ''}}
          </ng-template>
        </p-column>
        <p-column [sortable]="true" field="timezoneLabel" header="Time Zone" [style]="{'width':'150px'}" styleClass="hidden-sm"></p-column>
        <p-column [sortable]="true" field="name" header="Device Name" [style]="{'width':'200px'}" styleClass="col-nowrap ellipsis">
          <ng-template let-col let-data="rowData" pTemplate="body">
            <a [routerLink]="data.routeLink">{{data.name}}</a>
          </ng-template>
        </p-column>
        <p-column [sortable]="true" field="type" header="Type" [style]="{'width':'120px'}" styleClass="col-nowrap">
        </p-column>
        <p-column [sortable]="true" field="desc" header="Description" [style]="{'width':'420px'}" styleClass="col-nowrap"></p-column>
        <ng-template pTemplate="emptymessage">
          No Event found
        </ng-template>
      </p-dataTable> -->

      <p-table class="deviceTable pageAllOptions" #dt exportFilename="eventLogs" [columns]="eventLogs_cols" [value]="eventLogs" [rows]="10"
               [paginator]="true" [rowsPerPageOptions]="[10,20,{showAll:'All'}]" [scrollable]="true"
               (sortFunction)="customSort($event)" [customSort]="true">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr>
            <td style="width: 80px" class="col-nowrap text-center">
              <span class="center" *ngIf="!rowData.isHardwareFault">
                <i class="fa {{rowData.icon}} {{rowData.status}}" aria-hidden="true"></i>
              </span>
              <div class="icon errorCodeIcon" *ngIf="rowData.isHardwareFault">
                <!-- <span>H</span> -->
                <i class="fa fa-exclamation-triangle" aria-hidden="true" [ngStyle]="{'color': rowData.faultLevelColor}"></i>
              </div>
            </td>
            <td style="width: 250px" class="col-nowrap ellipsis" *ngIf="!rowData.IsMsp else regionNameTd">{{rowData.Account}}</td>
            <ng-template #regionNameTd>
              <td style="width: 250px" class="col-nowrap ellipsis">{{rowData.Region}}</td>
            </ng-template>
            <td style="width: 180px" class="col-nowrap ellipsis">{{rowData.DeviceSubType}}</td>
            <td style="width: 170px" class="col-nowrap">
              {{(rowData.time != null) ? ((rowData.timestamp * 1000) + ((localTimeZone + rowData.timeZone)* 60 * 60 * 1000) | date: 'yyyy/MM/dd HH:mm:ss') : ''}}
            </td>
            <td style="width: 150px" class="hidden-sm">{{rowData.timezoneLabel}}</td>
            <td style="width: 200px" class="col-nowrap ellipsis">
              <a [routerLink]="rowData.routeLink">{{rowData.name}}</a>
            </td>
              <td style="width: 150px" class="col-nowrap" *ngIf="rowData.CardType === undefined; else firmwareConnectionTypeStr">
                {{rowData.DisplaySourceType | displaySourceTypeCode : 'SubType'}}</td>
              <ng-template #firmwareConnectionTypeStr>
                <td style="width: 150px" class="col-nowrap">{{rowData.CardModel}}</td>
              </ng-template>
            <!-- <td style="width: 150px" class="col-nowrap">{{rowData.DisplaySourceType | displaySourceTypeCode : 'SubType'}}</td> -->
            <td style="width: 420px" class="col-nowrap">{{rowData.desc}}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="eventLogs_cols.length">
              <div class="ui-emptymessage">No Event found</div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<div class="content" *ngIf="isMsp">
  <div class="container-fluid">
    <div class="page-title">
      <h1>Event Monitoring</h1>
      <button pButton type="button" label="Export" icon="pi pi-download" class="{{Confirm_button}}" (click)="dt.exportCSV()"></button>
    </div>
    <div class="page-content">
      <section>
        <div class="row">
          <div class="col-lg-2 col-sm-12">
            <div class="main-side">
              <h5 class="main-side-title" translate>Company</h5>
              <div class="content-list tree">
                <p-treeTable [value]="treeRegion" selectionMode="single" [(selection)]="selectedRegion" (onNodeSelect)="onRegionSelect($event)"
                             (onNodeUnselect)="onRegionUnselect($event)" (selectionChange)="selectionRegionChange()">
                  <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
                    <tr [ttSelectableRow]="rowNode" [ngClass]="
                    {'critical': rowData.critical_event_count > 0 || rowData.warning_event_count > 0 && rowData.critical_event_count > rowData.warning_event_count,
                     'warning': rowData.critical_event_count > 0 || rowData.warning_event_count > 0 && rowData.warning_event_count >= rowData.critical_event_count}">
                      <td style="width:160px" class="col-nowrap ellipsis">
                        <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                        <span title="{{rowData.RegionName}}">{{rowData.RegionName}}</span>
                      </td>
                      <td style="width:60px"><span class="badge badge-pill badge-light">{{ rowData.all_event_count }}</span></td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr *ngIf="!pageLoading">
                      <td translate>No Data found</td>
                    </tr>
                    <ng-container *ngIf="pageLoading">
                      <tr *ngFor="let item of treeRegionGrid_Region">
                        <td>
                          <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 12, 'background-color': '#e9eef0'}"></p-skeleton>
                        </td>
                      </tr>
                    </ng-container>
                  </ng-template>
                </p-treeTable>
              </div>
            </div>
          </div>
          <div class="col-lg-10 col-sm-12">
            <div class="main-content">
              <div class="page-filter clearfix multiple-filter border-b-radius-none">
                <div class="filter-flex">
                  <div class="filter">
                    <div class="filter-list">
                      <div class="filter-content">
                        <p-select [options]="pro_statusOptions" [(ngModel)]="device_status" (onChange)="changeStatus()" [style]="{'width':'100%'}" placeholder="Status" class="select">
                          <ng-template let-item pTemplate="selectedItem">
                            <span>{{item.label}}</span>
                            <span class="badge badge-secondary {{item.label}}">{{item.title}}</span>
                          </ng-template>
                          <ng-template let-item pTemplate="item">
                            <div class="flex">
                              <span class="label">{{item.label}}</span>
                              <span class="badge badge-secondary {{item.label}}">{{item.title}}</span>
                            </div>
                          </ng-template>
                        </p-select>
                      </div>
                    </div>
                    <div class="filter-list">
                      <div class="filter-content">
                        <!-- <span class="type">Range</span> -->
                        <p-select [options]="rangeOptions" [(ngModel)]="selectedRange" (onChange)="dispatchRangeFilter()" [style]="{'width':'100%'}" placeholder="Range">
                        </p-select>
                      </div>
                    </div>
                  </div>
                  <div class="filter search float-right">
                    <div class="button">
                      <!-- <input #gb type="text" pInputText placeholder="Search" class="pInputText"> -->
                      <input type="text" pInputText placeholder="Search" (input)="dt.filterGlobal($event.target.value, 'contains')" class="pInputText">
                    </div>
                  </div>
                </div>
              </div>
              <div class="page-filter clearfix" style="margin: 0">
                <div class="page-title sub-title">
                  <h5 class="float-left color-black margin-none">{{selectedRegionName || 'All'}}</h5>
                </div>
              </div>
              <div class="border-t-radius-none">
                <p-table class="deviceTable pageAllOptions" #dt exportFilename="eventLogs" [columns]="eventLogs_pro_cols" [value]="eventLogs" [rows]="10"
                         [paginator]="true" [rowsPerPageOptions]="[10,20,{showAll:'All'}]" [scrollable]="true"
                         (sortFunction)="customSort($event)" [customSort]="true">
                  <ng-template pTemplate="header" let-columns>
                    <tr>
                      <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
                        {{col.header}}
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                      <td style="width: 80px" class="col-nowrap text-center">
                        <span class="center" *ngIf="!rowData.isHardwareFault">
                          <i class="fa {{rowData.icon}} {{rowData.status}}" aria-hidden="true"></i>
                        </span>
                        <div class="icon errorCodeIcon" *ngIf="rowData.isHardwareFault">
                          <!-- <span>H</span> -->
                          <i class="fa fa-exclamation-triangle" aria-hidden="true" [ngStyle]="{'color': rowData.faultLevelColor}"></i>
                        </div>
                      </td>
                      <td style="width: 250px" class="col-nowrap ellipsis">{{rowData.Region}}</td>
                      <td style="width: 180px" class="col-nowrap ellipsis">{{rowData.DeviceSubType}}</td>
                      <td style="width: 170px" class="col-nowrap">
                        {{(rowData.time != null) ? ((rowData.timestamp * 1000) + ((localTimeZone + rowData.timeZone)* 60 * 60 * 1000) | date: 'yyyy/MM/dd HH:mm:ss') : ''}}
                      </td>
                      <td style="width: 150px" class="hidden-sm">{{rowData.timezoneLabel}}</td>
                      <td style="width: 200px" class="col-nowrap ellipsis">
                        <a [routerLink]="rowData.routeLink">{{rowData.name}}</a>
                      </td>
                      <td style="width: 200px" class="col-nowrap">{{rowData.DisplaySourceType | displaySourceTypeCode : 'SubType'}}</td>
                      <td style="width: 420px" class="col-nowrap">{{rowData.desc}}</td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td [attr.colspan]="eventLogs_cols.length">
                        <div class="ui-emptymessage">No Event found</div>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
